import { combineReducers } from 'redux';

// Reducers
// import warehouseReducer from './Warehouse/store/warehouseReducer';
import colliReducer from './Colli/store/colliReducer';
import colliTypeReducer from './ColliType/store/colliTypeReducer';
import colliHistoryReducer from './ColliHistory/store/colliHistoryReducer';

export const subComponents = (translations) => [
    { name: translations["orders"] || "Orders", path: '/orders', permissions: ['order'] },
    { name: translations["transport_collies"] || "Transport container", path: '/transport-container', permissions: ['transport_colli'] },
    { name: translations["stock"] || "Container", path: '/container', permissions: ['colli_list'] },
    { name: translations["warehouses"] || "Warehouses", path: '/warehouses', permissions: ['warehouse_list'] },
]

export const reducers = combineReducers({
    // warehouse: warehouseReducer,
    colli: colliReducer,
    colliType: colliTypeReducer,
    colliHistory: colliHistoryReducer
});

